module.exports = __webpack_public_path__ + "static/media/zhuwairenyuanpaiqianxieyishu.27328622.png";